var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlanPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4893 11.7604H11.4973C9.42718 11.7604 7.749 13.4385 7.749 15.5087V29.0027C7.749 31.0728 9.42718 32.751 11.4973 32.751H29.4893C31.5595 32.751 33.2377 31.0728 33.2377 29.0027V15.5087C33.2377 13.4385 31.5595 11.7604 29.4893 11.7604ZM11.4973 9.51135C8.1851 9.51135 5.5 12.1964 5.5 15.5087V29.0027C5.5 32.3149 8.1851 35 11.4973 35H29.4893C32.8016 35 35.4867 32.3149 35.4867 29.0027V15.5087C35.4867 12.1964 32.8016 9.51135 29.4893 9.51135H11.4973Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.096 7C15.655 7 16.1081 7.45311 16.1081 8.01205L16.1081 9.36145C16.1081 9.92039 15.655 10.3735 15.096 10.3735C14.5371 10.3735 14.084 9.92039 14.084 9.36145L14.084 8.01205C14.084 7.45311 14.5371 7 15.096 7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.891 7C26.4499 7 26.903 7.45311 26.903 8.01205L26.903 9.36145C26.903 9.92039 26.4499 10.3735 25.891 10.3735C25.332 10.3735 24.8789 9.92039 24.8789 9.36145L24.8789 8.01205C24.8789 7.45311 25.332 7 25.891 7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8067 15.5089H14.1808C13.5337 15.5089 12.9971 16.0187 12.9971 16.6334C12.9971 17.2481 13.5337 17.7579 14.1808 17.7579H26.8067C27.4538 17.7579 27.9904 17.2481 27.9904 16.6334C27.9904 16.0187 27.4538 15.5089 26.8067 15.5089Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanPost);
export default __webpack_public_path__ + "static/media/planPost.d5ae28c0.svg";
export { ForwardRef as ReactComponent };